import { siteConfig } from "../config/site";

export default function Footer() {
  const year = new Date().getFullYear();
  const { social, images, artist } = siteConfig;
  return (
    <footer data-testid="site-footer" className="relative border-t border-[color:var(--yicel-violet)]/15 py-10">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <a href="#top" data-testid="footer-logo" className="block">
          <img
            src={images.logo}
            alt={artist.name}
            className="h-14 w-auto"
          />
        </a>
        <div className="flex items-center gap-5 text-sm text-[color:var(--yicel-muted)]">
          <a href={social.instagram} target="_blank" rel="noreferrer" className="hover:text-ink transition">Instagram</a>
          <a href={social.tiktok} target="_blank" rel="noreferrer" className="hover:text-ink transition">TikTok</a>
          <a href={social.youtube} target="_blank" rel="noreferrer" className="hover:text-ink transition">YouTube</a>
        </div>
        <p className="text-xs text-[color:var(--yicel-muted)]">
          © {year} Yicel · Hecho con el corazón.
        </p>
      </div>
    </footer>
  );
}
